var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5223 2.886C13.9611 2.10925 12.0507 1.65234 9.9875 1.65234C7.92426 1.65234 6.01389 2.10925 4.45271 2.88601C3.68712 3.26692 3.30433 3.45738 2.93342 4.05622C2.5625 4.65506 2.5625 5.23489 2.5625 6.39456V9.27293C2.5625 13.9617 6.30995 16.5687 8.48023 17.6852C9.08553 17.9967 9.38814 18.1523 9.9875 18.1523C10.5869 18.1523 10.8895 17.9967 11.4947 17.6852C13.665 16.5687 17.4125 13.9617 17.4125 9.27293V6.39457C17.4125 5.2349 17.4125 4.65506 17.0416 4.05622C16.6707 3.45738 16.2879 3.26692 15.5223 2.886Z",
    stroke: "#222222",
    strokeWidth: 0.995429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98906 7.42617V8.25116M9.16406 7.83867C9.16406 8.05748 9.25102 8.26733 9.40571 8.42201C9.56039 8.57678 9.77027 8.66366 9.98906 8.66366C10.2079 8.66366 10.4177 8.57678 10.5724 8.42201C10.7271 8.26733 10.8141 8.05748 10.8141 7.83867C10.8141 7.61987 10.7271 7.41003 10.5724 7.25531C10.4177 7.10059 10.2079 7.01367 9.98906 7.01367C9.77027 7.01367 9.56039 7.10059 9.40571 7.25531C9.25102 7.41003 9.16406 7.61987 9.16406 7.83867Z",
    stroke: "#222222",
    strokeWidth: 0.995429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6047 11.5516H9.36719L9.98594 8.66406L10.6047 11.5516Z",
    stroke: "#222222",
    strokeWidth: 0.995429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5922a1dab78f62214dd650cf252116a8.svg";
export { ForwardRef as ReactComponent };